var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.876,
    height: 25,
    viewBox: "0 0 47.876 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_18368",
    "data-name": "Raggruppa 18368",
    transform: "translate(-402.345 -549.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23360",
    "data-name": "Tracciato 23360",
    d: "M413.907,562.185a1.5,1.5,0,0,0-1.5-1.5h-8.562a1.5,1.5,0,0,0,0,3h8.562A1.5,1.5,0,0,0,413.907,562.185Z",
    transform: "translate(0 -0.438)",
    fill: "#a5a9c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23361",
    "data-name": "Tracciato 23361",
    d: "M414.044,567.693h-6.8a1.5,1.5,0,0,0,0,3h6.8a1.5,1.5,0,1,0,0-3Z",
    transform: "translate(0 -0.706)",
    fill: "#a5a9c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23362",
    "data-name": "Tracciato 23362",
    d: "M414.17,553.676h-7.187a1.506,1.506,0,0,0,0,3h7.187a1.506,1.506,0,0,0,0-3Z",
    transform: "translate(0 -0.169)",
    fill: "#a5a9c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23363",
    "data-name": "Tracciato 23363",
    d: "M447.935,549.247H420.164a2.308,2.308,0,0,0-2.288,2.324v20.353a2.308,2.308,0,0,0,2.288,2.324h27.771a2.308,2.308,0,0,0,2.287-2.324V551.571A2.308,2.308,0,0,0,447.935,549.247Zm-3.278,2.9L434.049,561.1l-10.614-8.956Zm-23.928,19.2V553.63l12.41,10.471a1.408,1.408,0,0,0,1.822,0l12.409-10.476v17.725Z",
    fill: "#a5a9c7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmail);
export default __webpack_public_path__ + "static/media/send-email.0786a46f.svg";
export { ForwardRef as ReactComponent };